import { formatPercent, formatUsdcRaw } from "../../lib/format";
import { WeightCell } from "./WeightCell";

/**
 * Free USDC sitting in the wallet, shown at the top of the table as a
 * pseudo-position so the user sees the full picture. Treated as 0%
 * APY / 0d exit; not withdrawable (already in the wallet).
 */
export function CashRow({
	cashUsdcRaw,
	totalValueUsdcRaw,
}: {
	cashUsdcRaw: string;
	totalValueUsdcRaw: string;
}) {
	const total = BigInt(totalValueUsdcRaw);
	const weight = total === 0n ? 0 : Number(BigInt(cashUsdcRaw)) / Number(total);
	return (
		<tr className="bg-slate-950/40">
			<td className="px-3 py-2 font-mono text-xs text-slate-200">
				Cash
				<div className="text-[10px] text-slate-500">
					USDC · idle wallet balance
				</div>
			</td>
			<td className="px-3 py-2 text-right font-mono">
				{formatUsdcRaw(cashUsdcRaw)}
			</td>
			<td className="px-3 py-2">
				<WeightCell weight={weight} />
			</td>
			<td className="px-3 py-2 text-right font-mono text-slate-500">
				{formatPercent(0)}
			</td>
			<td className="px-3 py-2 text-right text-slate-500">0d</td>
			<td className="px-3 py-2" />
		</tr>
	);
}
